import { AuthClient } from "@/utils/client";
import urlcat from "urlcat";
import client from "@/utils/client";
import { useRouter } from "next/router";

/**
 *
 * @param limit limit of the data, pass empty string to get all data
 * @param page page number
 * @param search search query
 * @param sortBy sort by field
 * @param otherFilters other filters
 * @returns list of my mineral collection
 */



export const getCategoryCollection = (
  limit?: number | string,
  page?: number,
  search?: string,
  
) => {
  const url = urlcat("/common/category", {
    limit,
    page,
    search,
  });

  return AuthClient().get(url);
};




export const getAllArticle = (
  limit?: number | string,
  page?: number,
  category?: string,
) => {

  const url = urlcat("/common/article", {
    limit,
    page,
    category,
  });

  return AuthClient().get(url);
};




export const getArticleDetails = (id: string | null) => {
  return client.get(`/common/article/${id}`);
};




export const getRelatedArticle = (
  search?: string,
) => {
  const url = urlcat("/common/related-article", {
    search,
  });

  return AuthClient().get(url);
};


